import React from "react";
import studyWithNoBorders from "../../../../../images/web/study-with-no-borders.webp";
import Button from "../../../components/ui/Button";
import { Calendar } from "lucide-react";

interface AlertProps {
  title: string;
  text: string;
  link?: string;
}

interface BannerProps {
  alert?: AlertProps;
}

const Banner: React.FC<BannerProps> = ({ alert }) => {
  const handleBookConsultation = () => {
    window.open(
      "https://cal.com/seamlessvisa/consultation",
      "_blank",
    );
  };

  return (
    <>
      <section className="relative pt-2 pb-0 lg:pt-6 overflow-hidden flex flex-col items-center text-center bg-linear-to-t from-blue-ea to-white">
        {/* Alert Pill — only shown when alert prop is provided */}
        {alert && (
          <div
            className={`inline-flex bg-blue-ea border border-blue-100 text-[#022E58] rounded-full p-1 text-xs md:text-sm font-semibold mb-6 gap-2 items-center shadow-sm ${alert.link ? "cursor-pointer hover:opacity-80 transition-opacity" : ""}`}
            onClick={alert.link ? () => window.open(alert.link, "_blank") : undefined}
          >
            <span className="bg-[#bdecb6] px-2 py-0.5 rounded-full text-green-900 uppercase tracking-widest text-[10px] md:text-xs font-bold leading-none">
              {alert.title}
            </span>
            <span className="pr-3 font-medium">
              {alert.text} <span aria-hidden>→</span>
            </span>
          </div>
        )}

        {/* Text Area */}
        <h1 className="text-h1 font-light font-lato tracking-tight text-[#022E58] max-w-5xl px-4 z-10 relative">
          Your{" "}
          <span className="inline-flex bg-blue-00 border-8 border-blue-ea! text-white px-3 pb-1 rounded-3xl rotate-2 hover:rotate-0 italic mx-1 shadow-md duration-150">
            Education
          </span>
          , <br className="hidden md:block" /> Without Borders
        </h1>
        <p className="mt-6 max-w-2xl text-black-31 leading-relaxed px-6 z-10 font-medium font-lato">
          Gain admission to world-renowned institutions in Australia, Canada,
          Ireland, the United Kingdom, and the United States. We transform
          ambitious students into successful applicants.
        </p>

        {/* CTAs */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 z-20 px-6 w-full sm:w-auto relative mb-4">
          <Button
            label="Book Consultation"
            onClick={handleBookConsultation}
            variant="primary"
            size="large"
            startIcon={<Calendar className="w-5 aspect-square" />}
            iconHoverStyle="scale"
            fullWidth
          />
        </div>

        {/* Main Image */}
        <div className="relative w-full max-w-480 -mt-2 md:-mt-64 lg:-mt-80 flex justify-center px-0">
          <img
            src={studyWithNoBorders}
            alt="Study With No Borders"
            className="w-full h-auto object-cover object-top drop-shadow-2xl"
          />
        </div>
      </section>
    </>
  );
};

export default Banner;
